export enum EScheduleType {
  ARRIVAL = 'arrival',
  DEPARTURE = 'departure'
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/enums/e-schedule-type.enum.ts